module.exports = __webpack_public_path__ + "static/media/Test36.4a9fdc01.bmp";